import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sdg-starting-page" }
const _hoisted_2 = { class: "sdg-starting-page-panel--left" }
const _hoisted_3 = { class: "sdg-starting-page-panel__wrapper" }
const _hoisted_4 = { class: "sdg-starting-page-panel__title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  style: {"width":"100%","text-align":"center"},
  class: "question-panel__content-wrapper"
}
const _hoisted_7 = { class: "sdg-starting-page-panel--right affiliate-description-panel" }
const _hoisted_8 = { class: "affiliate-description-panel__title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["alt", "src"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'sdg-starting-page-panel--simplified': !_ctx.withTeamSection,
      }, "sdg-starting-page-panel"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.affiliateName), 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "sdg-starting-page-panel__subtitle" }, "SDG Reports", -1)),
          (_ctx.affiliate.summary)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sdg-starting-page-panel__content",
                innerHTML: _ctx.affiliate.summary
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[0] || (_cache[0] = _createStaticVNode("<p class=\"sdg-starting-page-panel__content\" data-v-7eea65b4> Get activity-level impact assessments, <br data-v-7eea65b4> quantified by U.N. Sustainable Development Goals (SDGs) <br data-v-7eea65b4> and sub-targets. </p><div class=\"sdg-starting-page-panel__sdg-images\" data-v-7eea65b4><img class=\"sdg-images\" src=\"/img/sdg/1.png\" data-v-7eea65b4><img class=\"sdg-images\" src=\"/img/sdg/2.png\" data-v-7eea65b4><img class=\"sdg-images\" src=\"/img/sdg/3.png\" data-v-7eea65b4><img class=\"sdg-images\" src=\"/img/sdg/4.png\" data-v-7eea65b4><img class=\"sdg-images\" src=\"/img/sdg/5.png\" data-v-7eea65b4></div>", 2))
              ], 64)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"width":"100%","text-align":"center","margin-top":"24px","margin-bottom":"24px","font-weight":"500"} }, " Powered by Vested Impact ", -1)),
          (_ctx.$user.isLogged())
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.$user.isEntrepreneur())
                  ? (_openBlock(), _createBlock(_component_PxButton, {
                      key: 0,
                      icon: _ctx.startButtonIcon,
                      type: _ctx.startButtonType,
                      class: "sdg-starting-page-panel__button",
                      size: "large",
                      onClick: _ctx.onSelfAssessmentButtonClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.startButtonText), 1)
                      ]),
                      _: 1
                    }, 8, ["icon", "type", "onClick"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("p", null, "Assessments are only open for entrepreneurs", -1)
                    ]))]))
              ], 64))
            : (_openBlock(), _createBlock(_component_PxButton, {
                key: 3,
                icon: _ctx.startButtonIcon,
                type: _ctx.startButtonType,
                class: "sdg-starting-page-panel__button",
                size: "large",
                onClick: _ctx.onLoginButtonClick
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Login to start your assessment ", -1)
                ]))]),
                _: 1
              }, 8, ["icon", "type", "onClick"]))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionToDisplay, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(index + 1), 1),
              _createTextVNode(" " + _toDisplayString(item.title), 1)
            ]),
            _createElementVNode("div", {
              class: "affiliate-description-panel__description",
              innerHTML: item.description
            }, null, 8, _hoisted_9),
            (item.thumbnail)
              ? (_openBlock(), _createElementBlock("picture", {
                  key: `thumbnail-${index}`
                }, [
                  _createElementVNode("img", {
                    style: {"margin-left":"10%","width":"180px"},
                    alt: item.thumbnail.alt,
                    src: item.thumbnail.src
                  }, null, 8, _hoisted_10)
                ]))
              : _createCommentVNode("", true),
            (item.note)
              ? (_openBlock(), _createElementBlock("div", {
                  key: `note-${index}`,
                  class: "affiliate-description-panel__note",
                  innerHTML: item.note
                }, null, 8, _hoisted_11))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ], 2)
  ]))
}